// Module
var code = "<svg width=\"40\" height=\"14\"> <line x1=\"0\" y1=\"0\" x2=\"40\" y2=\"0\"></line> </svg>";
// Exports
module.exports = code;